import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsTaskCommentsMessages = defineMessages(
  "panels-task-comments",
  en,
);
